// NPM MODULES
import React from 'react';
import { Button, Typography, Box } from '@mui/material';

import CustomModal from './CustomModal';

const StagedModal = ({
  showStaged,
  removeStaged,
  removeStagedSlow,
  performAction,
  performNoAction,
  stageTitle,
  stageConfirmation,
  stagePending,
  stageSuccess,
  stageFailure,
  stage,
  performErrorAction,
}) => {
  // Confirmation 0, pending 1
  if (stage <= 1) {
    return (
      <CustomModal
        title={stageTitle}
        open={showStaged}
        width={600}
        handleClose={() => removeStaged()}
        onClose={() => removeStaged()}>
        <Typography>
          {stage === 0 ? stageConfirmation : stagePending}
        </Typography>

        <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            disabled={stage === 0 ? false : true}
            onClick={() => performAction()}
            sx={{ marginRight: 1 }}
            color="secondary">
            Yes
          </Button>

          <Button
            variant="outlined"
            disabled={stage === 0 ? false : true}
            onClick={() =>
              performNoAction ? performNoAction() : removeStaged()
            }
            color="secondary">
            No
          </Button>
        </Box>
      </CustomModal>
    );
  }
  // Success 2, failure 3
  else if (stage >= 2) {
    let button = (
      <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={() => removeStaged()}
          color="secondary">
          Ok
        </Button>
      </Box>
    );

    if (performErrorAction && stage === 3) {
      button = (
        <Box sx={{ marginTop: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={() => performErrorAction()}
            sx={{ mr: 1 }}
            color="secondary">
            Yes
          </Button>

          <Button
            variant="outlined"
            onClick={() => removeStaged()}
            color="secondary">
            No
          </Button>
        </Box>
      );
    }

    return (
      <CustomModal
        title={stageTitle}
        open={showStaged}
        width={600}
        handleClose={() => removeStaged()}
        onClose={() => removeStaged()}
        onTransitionExited={
          removeStagedSlow ? () => removeStagedSlow() : undefined
        }>
        <Typography>{stage === 2 ? stageSuccess : stageFailure}</Typography>
        {button}
      </CustomModal>
    );
  }

  return null;
};

export default StagedModal;
